import React, { useState } from "react";
import chatwidgetService from "../../services/chatwidget.service";

// import thumbsUpIcon from './svgs/thumbs-up.svg';
// import thumbsDownIcon from './svgs/thumbs-down.svg';

import { ReactComponent as ThumbsUpIcon } from "./svgs/thumbs-up.svg";
import { ReactComponent as ThumbsDownIcon } from "./svgs/thumbs-down.svg";

const FeedbackButtons = ({ chatDetailId, feedbackRating }) => {
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(!!feedbackRating);
  const [currentRating, setCurrentRating] = useState(feedbackRating);

  const sendFeedback = async (rating) => {
    try {
      await chatwidgetService.submitFeedback(chatDetailId, rating);
      setFeedbackSubmitted(true);
      setCurrentRating(rating);
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  return (
    <div className="feedback-buttons">
      {!feedbackSubmitted ? (
        // {!feedbackSubmitted && (
        <div className="feedback-button-container">
          <button
            className="icon-button thumbs-up"
            onClick={() => sendFeedback("thumbs_up")}
          >
            {/* <img src={thumbsUpIcon} alt="Thumbs Up" /> */}
            <ThumbsUpIcon />
          </button>
          <div className="feedback-divider" />
          <button
            className="icon-button thumbs-down"
            onClick={() => sendFeedback("thumbs_down")}
          >
            {/* <img src={thumbsDownIcon} alt="Thumbs Down" /> */}
            <ThumbsDownIcon />
          </button>
        </div>
      ) : (
        <div className="feedback-status">
          {currentRating === "thumbs_up" ? "👍" : "👎"}
        </div>
      )}
    </div>
  );
};

export default FeedbackButtons;
